import React from 'react';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import columns from './columns';
import useAuthContext from '../../contexts/AuthContext';

const MissingParts = () => {
  const { user } = useAuthContext();

  return (
    <SimpleResourceLandingLayout
      resourceName="contractDocuments"
      populate="insurer"
      extraQuery={`status!=QUOTE&!previous_contract&status!=DELETE${
        user?.permissionManagement?.contracts ? '' : `&user=${user?._id}`
      }`}
      columns={columns()}
      withCreateButton={false}
      withUploadButton={false}
      deleteAction={false}
    />
  );
};

export default MissingParts;
